export default __webpack_public_path__ + "static/media/donasi.84935760.png";